/* eslint-disable @typescript-eslint/no-explicit-any */
import { alpha } from '@mui/material/styles';

const withAlphas = (color: { lightest: string; light: string; main: any; dark: string; darkest: string; contrastText: string; }) => {
  return {
    ...color,
    alpha4: alpha(color.main, 0.04),
    alpha8: alpha(color.main, 0.08),
    alpha12: alpha(color.main, 0.12),
    alpha30: alpha(color.main, 0.30),
    alpha50: alpha(color.main, 0.50)
  };
};

export const neutral = {
  50: '#F8F9FA',
  100: '#F3F4F6',
  200: '#E5E7EB',
  300: '#D2D6DB',
  400: '#9DA4AE',
  500: '#6C737F',
  600: '#4D5761',
  700: '#2F3746',
  800: '#1C2536',
  900: '#111927'
};

export const indigo = withAlphas({
  lightest: '#F5F7FF',
  light: '#EBEEFE',
  main: '#0066FF',
  dark: '#003CFF',
  darkest: '#312E81',
  contrastText: '#FFFFFF'
});

export const success = withAlphas({
  lightest: '#F0FDF9',
  light: '#3FC79A',
  main: '#427E46',
  dark: '#0B815A',
  darkest: '#134E48',
  contrastText: '#FFFFFF'
});

export const info = withAlphas({
  lightest: '#ECFDFF',
  light: '#CFF9FE',
  main: '#06AED4',
  dark: '#0E7090',
  darkest: '#164C63',
  contrastText: '#FFFFFF'
});

export const warning = withAlphas({
  lightest: '#FFFAEB',
  light: '#FEF0C7',
  main: '#F79009',
  dark: '#B54708',
  darkest: '#7A2E0E',
  contrastText: '#FFFFFF'
});

export const error = withAlphas({
  lightest: '#FEF3F2',
  light: '#FEE4E2',
  main: '#F04438',
  dark: '#B42318',
  darkest: '#7A271A',
  contrastText: '#FFFFFF'
});

/*-- ELLIE CARE COLORS -- */
//https://hihayk.github.io/scale/#4/6/50/80/-51/67/20/14/427E46/66/126/70/white
export const gris = withAlphas({
  lightest: '#9C9B9B',
  light: '#6F6F6E',
  main: '#3C3C3B',
  dark: '#D6D7DA',
  darkest: '#1E1E1E',
  contrastText: '#D8D8D8'
});

export const tiza = withAlphas({
  lightest: '#FFFFFF',
  light: '#FCFDFC',
  main: '#F6F6F8',
  dark: '#D6D7DA',
  darkest: '#B8B8BB',
  contrastText: gris.darkest
});

export const verde = withAlphas({
  lightest: '#BAC5A5',
  light: '#81A273',
  main: '#427E46',
  dark: '#306048',
  darkest: '#1F413E',
  contrastText: tiza.main
});

export const rojo = withAlphas({
  lightest: '#E65B84',
  light: '#DF4052',
  main: '#D73225',
  dark: '#A65E17',
  darkest: '#726A0C',
  contrastText: tiza.main
});

export const azul = withAlphas({
  lightest: '#44D8FF',
  light: '#22A4FF',
  main: '#0066FF',
  dark: '#0027DF',
  darkest: '#390080',
  contrastText: tiza.main
});

export const naranja = withAlphas({
  lightest: '#BFBE01',
  light: '#F79009',
  main: '#FC7826',
  dark: '#B54708',
  darkest: '#7A2E0E',
  contrastText: tiza.main
});

// export const template = withAlphas({
//   lightest: '',
//   light: '',
//   main: '',
//   dark: '',
//   darkest: '',
//   contrastText: tiza.main
// });

export const elliecolor = {
  gris,
  tiza,
  verde,
  rojo,
  naranja,
  azul,
};
